export default {
  en: {
    price: '%{amount} %{currency}',
    priceWithCents: '%{amount} %{currency} and %{cents} cents',
    rate: 'per %{rateText}'
  },
  fr: {
    price: '%{amount} %{currency}',
    priceWithCents: '%{amount} %{currency} et %{cents} centimes',
    rate: 'par %{rateText}'
  }
};